import { TextParagraph, ImageParagraph, SubheadingParagraph, ListParagraph, VideoParagraph } from './Paragraphs';
export const SectionBlock = ({ section, sec_id }) => (
  <section 
    className="container-fluid bg-white" 
    id={`${sec_id}`}
  >
    <div className="container py-3">
      <div className="flex flex-col justify-center">
        {section.sec_heading && (
          <div className="text-xl xl:text-2xl font-bold my-[20px] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text">
            {section.sec_heading} 
          </div>
        )}
        
        {section.paragraphs?.map((par, i) => (
          <ParagraphBlock key={i} par={par} sectionId={sec_id} index={i} />
        ))}
      </div>
    </div>
  </section>
);

const ParagraphBlock = ({ par, sectionId, index }) => {
  switch(par.type) {
    case 'video': return <VideoParagraph paragraph={par} />;
    case 'text': return <TextParagraph paragraph={par} />;
    case 'image': return <ImageParagraph paragraph={par} />;
    case 'subheading': return <SubheadingParagraph paragraph={par} sectionId={sectionId} index={index} />;
    case 'ol': return <ListParagraph paragraph={par} ordered />;
    case 'ul': return <ListParagraph paragraph={par} />;
    default: {
      console.log(par);
      return null;
    }
  }
}; 